import React from "react";
import PropTypes from "prop-types";
import Breadcrumbs from "./Breadcrumbs";
import CustomersFilter from "../containers/CustomersFilter";
import ProductsFilter from "../containers/ProductsFilter";
import OrdersFilter from "../containers/OrdersFilter";
import AlertNotification from "../containers/AlertNotification";
import { Collapse, Button } from "reactstrap";
import MediaQuery from "react-responsive";

const ContentHeader = ({
  title,
  breadCrumbs,
  filter,
  isFilterOpen,
  filterToggle,
  type,
  toggleCategorySidebar
}) => (
    <div>
      <MediaQuery query="(min-device-width: 480px)">
        <div className="row">
          <div className="col-sm">
            <div className="contentHeader">
              {/* {breadCrumbs && <Breadcrumbs breadcrumbs={breadCrumbs} />} */}

              {title && <h2 className="contentHeader__heading">{title}</h2>}
            </div>
          </div>
          <div className="d-flex justify-content-center">
            <AlertNotification />
          </div>
          <div className="col-sm">
            <div className="mt5 mb5 text-right">
              {filter ? (
                <Button
                  type="button"
                  className={
                    "btn-danger button-filter " + (isFilterOpen ? "active" : "")
                  }
                  onClick={filterToggle}
                />
              ) : (
                  ""
                )}
            </div>
          </div>
        </div>
      </MediaQuery>
      <div className="row">
        <MediaQuery query="(max-device-width: 479px)">
          <div className="col-10">
            <div className="contentHeader">
              {title && <h2 className="contentHeader__heading">{title}</h2>}
            </div>
          </div>
          <div className="col-2 d-flex justify-content-end">
            <div className="mt5 mb5 text-right">
              {filter ? (
                <Button
                  type="button"
                  className={
                    "btn-danger button-filter " + (isFilterOpen ? "active" : "")
                  }
                  onClick={filterToggle}
                />
              ) : (
                  ""
                )}
            </div>
          </div>
        </MediaQuery>
        <div className="col-12">
          <Collapse isOpen={isFilterOpen} className={filter ? "visible" : null}>
            {type === "customers" ? (
              <CustomersFilter />
            ) : type === "orders" ? (
              <OrdersFilter />
            ) : (
                  <ProductsFilter />
                )}
          </Collapse>
        </div>
      </div>
    </div>
  );

ContentHeader.defaultProps = {
  title: "Default title",
  breadCrumbs: [],
  filter: false,
  type: "products"
};

ContentHeader.propTypes = {
  title: PropTypes.string,
  breadCrumbs: PropTypes.array.isRequired,
  filter: PropTypes.bool,
  isFilterOpen: PropTypes.bool,
  filterToggle: PropTypes.func.isRequired,
  toggleCategorySidebar: PropTypes.func,
  type: PropTypes.string
};

export default ContentHeader;



// WEBPACK FOOTER //
// ./src/molecules/components/ContentHeader.js